import React, { Component } from 'react';
import Block from '../block';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Accordion from 'react-bootstrap/Accordion';
import { getIsPreviewStatus } from '../../state/app';
import { HtmlCode, RichText } from '../richTextOptions';
import { SvgIcon } from '../BlockLibrary/Common/SvgIcon'

const FAQItem = ({ faq, active, onClick, index }) => {
    const providerId = faq.sys ? `${faq.sys.id}-${index}` : `${faq.contentful_id}-${index}`;

    return (
        <>
            <Accordion.Toggle
                className="faq-question"
                aria-expanded={active}
                as="button"
                eventKey={providerId}
                onClick={onClick}
                aria-label="toggle"
            >
                <h3 className="question"><HtmlCode data={faq.faqQuestion}></HtmlCode></h3>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={providerId}>
                <div className="answer">
                    {
                        faq.faqAnswer && <RichText data={faq.faqAnswer}></RichText>
                    }
                </div>
            </Accordion.Collapse>
        </>
    )
}

class SectionFAQs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeFaqIndex: '',
            isLoadMore: false,
        }
    }

    setActiveFaqIndex = (index) => this.setState({ activeFaqIndex: index })

    showLoadMore = () => this.setState({ isLoadMore: true })

    componentDidMount() {
        const { faqItems, FAQsItemShowNumber } = this.props;
        if (FAQsItemShowNumber > faqItems.length) {
            this.showLoadMore();
        }
    }



    render() {
        const { faqItems, headline, FAQsItemShowNumber, linkToFAQsPage, sectionId, isPreview } = this.props;
        const { activeFaqIndex, isLoadMore } = this.state;
        let showFAQItems = faqItems;
        let hiddenFAQItems = [];
        let faqItemsPreview = [];
        if (isPreview) {
            if (faqItems.length > 0) {
                faqItemsPreview = faqItems.map((item, index) => {
                    return item.fields;
                })
            }
        }
        if (FAQsItemShowNumber > 0) {
            if (isPreview) {
                showFAQItems = faqItemsPreview.length > 0 ? faqItemsPreview.slice(0, FAQsItemShowNumber) : [];
                hiddenFAQItems = faqItemsPreview.length > FAQsItemShowNumber ? faqItemsPreview.slice(FAQsItemShowNumber) : [];
            } else {
                showFAQItems = faqItems.length > 0 ? faqItems.slice(0, FAQsItemShowNumber) : [];
                hiddenFAQItems = faqItems.length > FAQsItemShowNumber ? faqItems.slice(FAQsItemShowNumber) : [];
            }
        } else {
            if (isPreview) {
                showFAQItems = faqItemsPreview;
            }
        }
        const sectionIdFaq = sectionId ? sectionId : null

        return (
            <section id={sectionIdFaq} className='faqs pet-insurance-faqs'>
                <div className="container">
                    {typeof headline !== 'undefined' && <RichText data={headline} />}
                    {(typeof faqItems !== 'undefined' && faqItems.length > 0) && (
                        <Accordion>
                            <div className={`list-faqs`}>
                                {
                                    showFAQItems.map((faqItem, index) => {
                                        return (
                                            <div className={`faq ${activeFaqIndex === index ? 'active' : ''}`} key={index}>
                                                <FAQItem
                                                    index={index}
                                                    faq={faqItem}
                                                    active={activeFaqIndex === index}
                                                    onClick={() => { activeFaqIndex !== index ? this.setActiveFaqIndex(index) : this.setActiveFaqIndex('') }} />
                                            </div>
                                        )
                                    })
                                }
                                {!isLoadMore && hiddenFAQItems.length > 0 &&
                                    <p className="view-more view-more-icon">
                                        <button aria-label="view more" onClick={this.showLoadMore}>
                                            <SvgIcon type="arrow-down" />
                                        </button>
                                    </p>
                                }
                                {hiddenFAQItems.length > 0 ? (
                                    <>
                                        <div className={`hidden-faqs ${isLoadMore ? 'show' : ''}`}>
                                            {
                                                hiddenFAQItems.map((faqItem, i) => {
                                                    const index = i + FAQsItemShowNumber;
                                                    return (
                                                        <div className={`faq ${activeFaqIndex === index ? 'active' : ''}`} key={index}>
                                                            <FAQItem
                                                                index={index}
                                                                faq={faqItem}
                                                                active={activeFaqIndex === index}
                                                                onClick={() => { activeFaqIndex !== index ? this.setActiveFaqIndex(index) : this.setActiveFaqIndex('') }} />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>

                                        {(isLoadMore && linkToFAQsPage) && (
                                            <div className="cta-button">
                                                <Block block={linkToFAQsPage} />
                                            </div>
                                        )}
                                    </>
                                ) : (
                                        <>
                                            {(linkToFAQsPage) && (
                                                <div className="cta-button">
                                                    <Block block={linkToFAQsPage} />
                                                </div>
                                            )}
                                        </>
                                    )}
                                <div className="back-to-top-wrapper">
                                    <button className="back-to-top">Back to top
                                    </button>
                                </div>
                            </div>
                        </Accordion>
                    )}
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    return {
        isPreview: getIsPreviewStatus(state)
    };
}

SectionFAQs.propTypes = {
    isPreview: PropTypes.bool,
}
const ContentfulSectionFaQs = connect(mapStateToProps)(SectionFAQs);

export { ContentfulSectionFaQs }
